import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { NIGHT } from '~/art'
import { BrandMark } from '~/features/auth/AuthLayout'
import { useDocumentTitle } from '~/features/auth/form'
import { ButtonLink, Stage } from '~/ui'

/** Any path that matches no route (router defaultNotFoundComponent): the ball on the line, one way back. */
export function NotFound() {
  useDocumentTitle('Seite nicht gefunden')
  return (
    <main id="main" className="page-gutter mx-auto flex min-h-dvh w-full max-w-[1200px] flex-col py-6">
      <Link to="/" className="inline-flex items-center gap-2.5 self-start rounded-control text-body font-semibold text-ink">
        <BrandMark />
        SquadCore
      </Link>
      <Stage art={NIGHT} focus="object-[66%_50%]" scrim="left" priority className="mt-6 flex flex-1 flex-col justify-end md:justify-center">
        <div className="max-w-[520px] p-6 sm:p-10 md:p-16">
          <p className="text-small font-medium text-white/75">404</p>
          <h1 className="mt-3 text-[2.25rem] leading-[1.06] font-semibold tracking-[-0.03em] text-white text-balance md:text-[3.25rem]">
            Diese Seite steht im Abseits.
          </h1>
          <p className="mt-5 max-w-[420px] text-[1.0625rem] leading-relaxed text-white/80 text-pretty">
            Die Adresse gibt es nicht (mehr). Vielleicht wurde der Link gekürzt oder die Seite ist umgezogen.
          </p>
          <div className="mt-9">
            <ButtonLink to="/" variant="light" size="lg" icon={ArrowLeft}>
              Zur Startseite
            </ButtonLink>
          </div>
        </div>
      </Stage>
    </main>
  )
}
